import _Promise from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/promise";
import _JSON$stringify from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/json/stringify";
import _objectSpread from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread";
import "core-js/modules/es6.regexp.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _Object$keys from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/object/keys";
import "core-js/modules/web.dom.iterable";
import { getLang, creatUUid, faceServerEncrypt } from "../utils/apiHelper";
import { getTimeZone, isIpad } from "@/utils/lodash";
import Base64 from "crypto-js/enc-base64";
import Utf8 from "crypto-js/enc-utf8";
import { baseUrl } from "@/config/config";

var parseGetParam = function parseGetParam(params) {
  var result = "";

  _Object$keys(params).forEach(function (key) {
    result += "&".concat(key, "=").concat(params[key]);
  });

  return result;
};

export var addBodyDefaultParams =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(params) {
    var deviceInfo, defaultBodyParams;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            deviceInfo = window.device; // console.log("deviceInfo", deviceInfo);

            defaultBodyParams = {
              // platform: deviceInfo.appPlatform,
              app_version: deviceInfo.appVersion,
              js_bundle_version: process.env.VUE_APP_VERSION,
              platform_info: deviceInfo.verifyId,
              device_model: deviceInfo.model,
              timestamp: new Date().valueOf().toString(),
              request_id: creatUUid(),
              timezone: getTimeZone(),
              lang: getLang(),
              pad: isIpad(),
              mver: deviceInfo.appVersion,
              system_version: deviceInfo.version
            }; // console.log("defaultBodyParams:", defaultBodyParams);

            if (!(params === null || params === undefined)) {
              _context.next = 7;
              break;
            }

            params = defaultBodyParams;
            return _context.abrupt("return", params);

          case 7:
            params = _objectSpread({}, defaultBodyParams, params);
            return _context.abrupt("return", params);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function addBodyDefaultParams(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var addDefaultParamsAndEncrypt =
/*#__PURE__*/
function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(config) {
    var dataBody, dataStr, encryptData, paramsData;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            // console.log("addDefaultParamsAndEncrypt:", config);
            dataBody = {
              method: config.method,
              path: config.path,
              query: "",
              body: ""
            };

            if (!(config.method === "GET")) {
              _context2.next = 8;
              break;
            }

            _context2.next = 4;
            return addBodyDefaultParams(config.params);

          case 4:
            config.params = _context2.sent;
            dataBody.query = parseGetParam(config.params);
            _context2.next = 12;
            break;

          case 8:
            _context2.next = 10;
            return addBodyDefaultParams(config.data);

          case 10:
            config.data = _context2.sent;
            dataBody.body = config.data;

          case 12:
            console.log("dataBody", dataBody);
            dataStr = _JSON$stringify(dataBody);
            _context2.next = 16;
            return faceServerEncrypt(dataStr);

          case 16:
            encryptData = _context2.sent;
            // console.log("encryptData", encryptData);
            paramsData = {
              zv: "gps",
              data: encryptData
            };
            return _context2.abrupt("return", paramsData);

          case 19:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function addDefaultParamsAndEncrypt(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
export function defaultResponse(response) {
  try {
    if (response.data && response.status === 200) {
      return JSON.parse(response.data);
    } else {
      return _Promise.reject(response);
    }
  } catch (error) {
    return _Promise.reject(error);
  }
}
export function responseBase64(response) {
  try {
    if (response.hasOwnProperty("data") && response.hasOwnProperty("meta")) {
      //TODO：服务校验错误后 不会返回base64的编码，而是直接返回错误
      var words = Base64.parse(response.data);
      var textString = Utf8.stringify(words);
      return _objectSpread({}, response, {
        data: JSON.parse(textString)
      });
    } else {
      return _Promise.reject(response);
    }
  } catch (error) {
    // console.error("responseBase64失败", error);
    return _Promise.reject(error);
  }
}
export var resultFactory = function resultFactory(response) {
  try {
    console.log("resultFactory:", response);
    var defaultResponseResult = defaultResponse(response);
    return responseBase64(defaultResponseResult);
  } catch (error) {
    return _Promise.reject(error);
  }
};
export var encryptBaseRequest = function encryptBaseRequest(url, config) {
  //所有请求都是post请求：
  // console.log("encryptBaseRequest", url, config);
  return new _Promise(
  /*#__PURE__*/
  function () {
    var _ref3 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee3(resolve, reject) {
      var factoryData, realConfig;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return addDefaultParamsAndEncrypt(_objectSpread({
                path: url
              }, config));

            case 3:
              factoryData = _context3.sent;
              // console.log("factoryData", factoryData);
              realConfig = {
                method: "post",
                data: factoryData
              };

              if (config.headers) {
                realConfig.headers = config.headers;
              }

              console.log("realConfig:", realConfig);
              cordova.plugin.http.sendRequest(baseUrl, realConfig, function (response) {
                //base64解密：
                console.log("response:......", response);
                resolve(resultFactory(response));
              }, function (error) {
                // prints 403
                reject(error);
              });
              _context3.next = 13;
              break;

            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3["catch"](0);
              // console.log("faceServeBase error", error);
              reject(_context3.t0);

            case 13:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 10]]);
    }));

    return function (_x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }());
};